<template>
    <div class="container">
        <div class="col-lg-4 col-md-6 ml-auto mr-auto">
            <form>
                <card class="card-login card-white">
                    <template slot="header">
                        <img src="img/card-primary.png" alt=""/>
                        <h1 class="card-title">Forgot</h1>
                    </template>
                    <base-input
                            v-model="username"
                            v-validate="'required|email'"
                            :error="getError('username')"
                            name="username"
                            type="email"
                            placeholder="Email"
                            addon-left-icon="envelope"
                    >
                    </base-input>

                    <div slot="footer">
                        <base-button v-if="!success" type="primary" :loading="loading" v-on:click="validate"
                                     class="mb-3" size="lg"
                                     block>
                            <i v-if="success" class="fal fa-check "></i>
                            <span>Reset Password</span>
                        </base-button>
                        <p class="text-primary" v-if="success">Password reset has been sent! Check your email!</p>
                        <p class="text-danger" v-if="error">The supplied email address was invalid!</p>
                    </div>
                </card>
            </form>
        </div>
    </div>
</template>
<script>

    export default {
        components: {},
        data() {
            return {
                username: '',
                error: false,
                loading: false,
                success: false,
            };
        },
        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName);
            },
            validate() {
                this.error = false;
                this.success = false;
                this.$validator.validateAll().then(isValid => {
                    this.loading = true;
                    this.forgot();
                });
            },
            forgot: function () {
                const {username} = this;
                this.$store.dispatch('AUTH_PASS_RESET_REQUEST', {username}).then((resp) => {
                    this.success = true;
                }).catch(error => {
                    this.error = true;
                }).finally(() => {
                    this.loading = false;
                })
            }
        }
    };
</script>
<style>
    .navbar-nav .nav-item p {
        line-height: inherit;
        margin-left: 5px;
    }
</style>
